import vsComponent from './VxTable.vue';
import vsComponent4 from './VxTd.vue';
import vsComponent2 from './VxTh.vue';
import vsComponent3 from './VxTr.vue';

export default (Vue) => {
    Vue.component(vsComponent.name, vsComponent);
    Vue.component(vsComponent2.name, vsComponent2);
    Vue.component(vsComponent3.name, vsComponent3);
    Vue.component(vsComponent4.name, vsComponent4);
};
